module.exports = __webpack_public_path__ + "static/media/mgalleryone.24a0972e.jpg";